<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row d-flex">
          <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <div class="form-group">
              <label for>Selecione o(s) projeto(s) para visualizar os gráficos</label>

              <v-select
                placeholder="Digite o nome do projeto"
                v-model="project"
                :options="[
                  { label: 'Todos', id: $store.getters.emptyGuid },
                  ...projects
                ]"
                multiple
                required
              >
                <template slot="no-options">
                  Nenhum resultado para a busca.
                </template>
              </v-select>
            </div>
          </div>
          <div
            v-if="!loadingFilter"
            class="col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-4"
          >
            <button
              class="btn btn-primary mr-2"
              type="button"
              @click="OnChangeProject"
            >
              Filtrar
            </button>
          </div>
          <div v-else class="col-1 mt-4">
            <div class="loader">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>

          <div
            v-if="csv.itens.length > 0"
            class="btn-group ml-auto"
            role="group"
            aria-label="Basic example"
          >
            <button class="btn" title="Baixar dados para planilha">
              <download-csv
                title="Baixar dados planilha"
                :separator-excel="false"
                :name="'dashboard.csv'"
                :data="GetCsv()"
              >
                <i class="fas fa-file-excel fa-2x"></i>
              </download-csv>
            </button>

            <button
              class="btn mt-1"
              @click="GetPdf"
              title="Gerar relatório em PDF"
            >
              <i v-if="!loadingPdf" class="fas fa-file-pdf fa-2x"></i>
              <div v-else class="loader">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-card-group id="cardsCount" deck v-if="viewModel" class="mb-4">
      <b-card
        bg-variant="primary"
        text-variant="white"
        header="Total de Indivíduos Avaliados"
        class="text-center"
      >
        <b-card-text>
          <span style="font-size: 20px"> {{ viewModel.total }} </span>
        </b-card-text>
      </b-card>

      <b-card
        bg-variant="info"
        text-variant="white"
        header="Total de Vivas"
        class="text-center"
      >
        <b-card-text>
          <span style="font-size: 20px"> {{ viewModel.alive }} </span>
        </b-card-text>
      </b-card>

      <b-card
        bg-variant="success"
        text-variant="white"
        header="Total de Mortas"
        class="text-center"
      >
        <b-card-text
          ><span style="font-size: 20px"> {{ viewModel.dead }} </span>
        </b-card-text>
      </b-card>

      <b-card
        bg-variant="warning"
        text-variant="white"
        header="Total de Novos Plantios Potenciais"
        class="text-center"
      >
        <b-card-text>
          <span style="font-size: 20px"> {{ viewModel.new }} </span>
        </b-card-text>
      </b-card>
    </b-card-group>

    <div class="row mb-3 chart-print">
      <div class="col-12">
        <highcharts
          id="chartTopTree"
          v-if="chartTopTree"
          :options="chartTopTree"
        />
      </div>
    </div>
    <div class="row mb-3 chart-print">
      <div class="col-12">
        <highcharts
          id="chartColumnOrigin"
          v-if="chartColumnOrigin"
          :options="chartColumnOrigin"
        />
      </div>
    </div>

    <div class="row mb-3 chart-print">
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <highcharts
          id="chartPieHeigthClass"
          v-if="chartPieHeigthClass"
          :options="chartPieHeigthClass"
        />
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <highcharts
          id="chartPieOrigin"
          v-if="chartPieOrigin"
          :options="chartPieOrigin"
        />
      </div>
    </div>
    <div class="row mb-3 chart-print">
      <div class="col-12">
        <highcharts id="chartGaau" v-if="chartGaau" :options="chartGaau" />
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import ProjectService from "../../servico/ProjectService";
import DashboardService from "../../servico/DashboardService";
import CsvGaauService from "../../servico/CsvGaauService";
import GaauService from "../../servico/GaauService";
import DashboardReportPdf from "./Report/DashboardReportPdf";

export default {
  name: "Dashboard",
  components: {
    highcharts: Chart
  },
  data() {
    return {
      loadingPdf: false,
      loadingFilter: false,
      viewModel: null,
      project: null,
      projects: [],
      chartTopTree: null,
      chartColumnOrigin: null,
      chartPieHeigthClass: null,
      chartPieOrigin: null,
      chartGaau: null,
      csv: {
        itens: []
      }
    };
  },
  mounted() {
    this.OnSearchProjects("    ");
  },
  methods: {
    OnSearchProjects(term) {
      if (!term || term.length <= 2) return;

      ProjectService.GetVSelect(term, true)
        .then((result) => {
          this.projects = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    OnChangeProject() {
      this.viewModel = null;
      let ids = this.project.map((a) => {
        return a.id;
      });
      this.loadingFilter = true;
      DashboardService.GetTotalCard(ids)
        .then((result) => {
          this.viewModel = result.data;
          this.loadingFilter = false;
        })
        .catch((erro) => {
          this.loadingFilter = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      DashboardService.GetTopTree(ids)
        .then((result) => {
          this.loadingFilter = false;

          this.chartTopTree = DashboardService.ToTopTree(result.data);
        })
        .catch((erro) => {
          this.loadingFilter = false;

          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      DashboardService.GetOrigin(ids)
        .then((result) => {
          this.loadingFilter = false;

          this.chartColumnOrigin = DashboardService.ToColumn(
            result.data,
            "Distribuição diamétrica dos indivíduos arbóreos e palmeiras avaliados de acordo com a origem destes por intervalo de classe",
            ["#92d050", "#052c27"],
            "Intervalo de diâmetro (cm)"
          );
        })
        .catch((erro) => {
          this.loadingFilter = false;

          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      DashboardService.GetHeigthClass(ids)
        .then((result) => {
          this.loadingFilter = false;

          this.chartPieHeigthClass = DashboardService.ToPie(
            result.data,
            "Classe de Altura"
          );
        })
        .catch((erro) => {
          this.loadingFilter = false;

          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      DashboardService.GetPieOrigin(ids)
        .then((result) => {
          this.loadingFilter = false;

          this.chartPieOrigin = DashboardService.ToPie(
            result.data,
            "Origem das Espécies"
          );
        })
        .catch((erro) => {
          this.loadingFilter = false;

          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      DashboardService.GetGaau(ids)
        .then((result) => {
          this.loadingFilter = false;

          this.chartGaau = DashboardService.ToColumn(
            result.data,
            "Índice de GAAU",
            ["#D91818", "#FFBF00", "#FBFF00", "#009933"],
            ""
          );
        })
        .catch((erro) => {
          this.loadingFilter = false;

          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      GaauService.GetReportTables(ids)
        .then((result) => {
          this.csv = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetCsv() {
      return CsvGaauService.Get(this.csv.itens);
    },
    async GetPdf() {
      this.loadingPdf = true;
      await DashboardReportPdf.Execute();
      this.loadingPdf = false;
    }
  }
};
</script>
